/**
 * 6529.io API
 * This is the API interface description. Brief terminology overview and an authentication example can be found at <a href=\"https://6529.io/about/api\">https://6529.io/about/api</a>.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { ApiArtistsNft } from '../models/ApiArtistsNft';
import { ApiArtistsWork } from '../models/ApiArtistsWork';
import { HttpFile } from '../http/http';

export class ApiArtistItem {
    'name': string;
    'bio': string | null;
    'pfp': string | null;
    'memes': Array<ApiArtistsNft>;
    'memelab': Array<ApiArtistsNft>;
    'gradients': Array<number>;
    'work': Array<ApiArtistsWork>;
    'social_links': Array<any>;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "bio",
            "baseName": "bio",
            "type": "string",
            "format": ""
        },
        {
            "name": "pfp",
            "baseName": "pfp",
            "type": "string",
            "format": ""
        },
        {
            "name": "memes",
            "baseName": "memes",
            "type": "Array<ApiArtistsNft>",
            "format": ""
        },
        {
            "name": "memelab",
            "baseName": "memelab",
            "type": "Array<ApiArtistsNft>",
            "format": ""
        },
        {
            "name": "gradients",
            "baseName": "gradients",
            "type": "Array<number>",
            "format": "int64"
        },
        {
            "name": "work",
            "baseName": "work",
            "type": "Array<ApiArtistsWork>",
            "format": ""
        },
        {
            "name": "social_links",
            "baseName": "social_links",
            "type": "Array<any>",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return ApiArtistItem.attributeTypeMap;
    }

    public constructor() {
    }
}

